import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import AdminApp from './AdminApp';
import { GlobalStyles } from './styles/GlobalStyles';
import AgfApp from './AgfApp';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <GlobalStyles />
    {/* <AdminApp /> */}
    <App />
    {/* <AgfApp /> */}
  </React.StrictMode>
);